import React, { useState } from 'react';
import {
  Dropdown,
  DropdownButton,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { Edit } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ModalEditDevice from '../Modal/ModalEditDevice';
import ModalTransferCustomer from '../Modal/ModalTransferCustomer';

const DropdownEditCustomer = ({ deviceId, deviceProfileId, customerId }) => {
  const { t } = useTranslation();
  const [isUpdateShow, setIsUpdateShow] = useState(false);
  const [isContainerShow, setIsContainerShow] = useState(false);
  const dataUser = useSelector((state) => state.profile.profile);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('error-permission')}
    </Tooltip>
  );

  return (
    <>
      {dataUser.authority === 'TENANT_ADMIN' ? (
        <>
          <DropdownButton
            size="sm"
            key="end"
            id="dropdown-button-drop-end"
            drop="end"
            variant="success"
            title={<Edit />}
          >
            <Dropdown.Item onClick={() => setIsContainerShow(true)}>
              {t('edit-device')}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setIsUpdateShow(true)}>
              {t('customer-transfer')}
            </Dropdown.Item>
          </DropdownButton>
          <ModalTransferCustomer
            setShow={setIsUpdateShow}
            show={isUpdateShow}
            deviceId={deviceId}
          />
          <ModalEditDevice
            setShow={setIsContainerShow}
            show={isContainerShow}
            deviceId={deviceId}
            deviceProfileId={deviceProfileId}
            customerId={customerId}
          />
        </>
      ) : (
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <i
            class="fa fa-ban"
            style={{ color: 'red', fontSize: '25px' }}
            aria-hidden="true"
          ></i>
        </OverlayTrigger>
      )}
    </>
  );
};

export default DropdownEditCustomer;
